// Missing or invalid measurements remain unknown. A recorded zero is data.
function sleepValue(value: unknown, maximum: number): number | null {
  return typeof value === "number" && Number.isFinite(value) && value >= 0 && value <= maximum ? value : null;
}

export function sleepDurationValue(value: unknown): number | null {
  return sleepValue(value, 24);
}

export function sleepScoreValue(value: unknown): number | null {
  return sleepValue(value, 100);
}
